// class-component-hooks.ts
import Component from 'vue-class-component'

// https://class-component.vuejs.org/guide/additional-hooks
// Register the router hooks with their names
Component.registerHooks([
  'metaInfo',
  'validations',
  'subscriptions',
])
